import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 100px;
`;

export const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
`;
